/**
 * Strip HTML tags повністю — для AI-summary та preview-рядків де
 * форматування не потрібне і теги показуються як plain text (баг
 * коли AI генерує summary з <b>...</b> всередині).
 */
export function stripHtml(text: string | null | undefined): string {
  if (!text) return "";
  // Прибираємо теги
  let s = text.replace(/<[^>]*>/g, "");
  // Декодуємо basic entities
  s = s
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, " ");
  // Collapse whitespace
  return s.replace(/\s+/g, " ").trim();
}
